<script>
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
var CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;
import { AZEventBus } from './AZEventBus.js'

export default {
  props: ['owner'],
  data: function() {
    return {
      USER_POOL: {},
      cuForCompleteReg: null,
      region: process.env.REGION,
      clientId: process.env.AWS_COG_CLIENT_ID,
      userPoolId: process.env.AWS_COG_USER_POOL_ID,
      identityPoolId: process.env.AWS_COG_IDENTITY_POOL_ID
    };
  },
  created: function() {
    var self = this;
    //Global User Pool
    this.USER_POOL = new AmazonCognitoIdentity.CognitoUserPool({
      UserPoolId: self.userPoolId,
      ClientId: self.clientId
    });
  },
  methods: {
    signUp: function(email, pass, attributes, callBack) {
      var self = this;
      var user_pool = self.USER_POOL;
      var attributeList = [];

      var attribute = {};
      for (var i = 0; i < attributes.length; i++) {
        attribute = new AmazonCognitoIdentity.CognitoUserAttribute(
          attributes[i]
        );
        attributeList.push(attribute);
      }

      user_pool.signUp(email, pass, attributeList, null, function(err, result) {
        if (err) {
          console.log(err);
          callBack("error", err);
          return;
        }
        callBack("success", result);
      });
    },
    authenticate: function(user, pass, callBack) {
      var self = this;
      var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
        {
          Username: user,
          Password: pass
        }
      );
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser(
        {
          Username: user,
          Pool: self.USER_POOL
        }
      );

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function(session) {
         
          // get user attributes
          self.getUserAttributes(attrsCallback);

          function attrsCallback(result) {
            if (!result) {
            } else {
              callBack("success", result);
            }
          }
        },
        onFailure: function(err) {
          console.log(err);
          callBack("error", err);
        },

        newPasswordRequired: function(userAttributes, requiredAttributes) {
          self.cuForCompleteReg = cognitoUser;
          callBack("changePwd");
        }
      });
    },
    getUserAttributes: function(callBack) {
      var self = this;
      var cognitoUser = self.USER_POOL.getCurrentUser();

      if (cognitoUser != null) {
        cognitoUser.getSession(function(err, session) {
          if (err) {
            console.log(err);
            return;
          }

          let federate = self.federateUser(session);

          cognitoUser.getUserAttributes(function(err, result) {
            if (err) {
              console.log(err);
              self.logOutUser(null);
              callBack(false);
            } else {
              callBack(result); 
            }
          });

          /* AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId : '...', // your identity pool id here
            Logins : {
              // Change the key below according to the specific region your user pool is in.
              'cognito-idp.<region>.amazonaws.com/<YOUR_USER_POOL_ID>' : session.getIdToken().getJwtToken()
            }
          }); */

        });
      } else {
        self.federateUser();
        callBack(false);
      }
    },
    refreshSession: async function(){
        var self = this
        var cognitoUser = await this.USER_POOL.getCurrentUser();

        //console.log('refreshSession')

        await cognitoUser.getSession(function(err, session) {
          //console.log('getSession')
          if (err) {
            console.log(err);
            return ;
          }

        return new Promise(async(res, rej) => {
          //let yes = false
           await cognitoUser.refreshSession(session.refreshToken, async (err, newSession) => {
              if (err){ 
                rej(err)
              } else { 
                console.log('refreshSession')
                let a = await self.federateUser(newSession, true)
                //console.log(a)
                if(a == 'success') res()
              }
            })
        });
        })
    },
    federateUser: async function(currentSession, fromRefresh) {

      var self = this;
      // setup login
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: this.identityPoolId,
        Logins: {}
      });

    
      let session = currentSession;

      AWS.config.update({ region: this.region });

      // Add token if session exists
      if (session) {
        AWS.config.credentials.params.Logins[`cognito-idp.${this.region}.amazonaws.com/${this.userPoolId}`] = session.getIdToken().getJwtToken();
      } else {
        AWS.config.credentials.params.Logins = {};
      }

      AWS.config.credentials.expired = true;

      // Call cognito for temp credentials
      return new Promise((res, rej) => {
        // API Call #2 to federate
        AWS.config.credentials.get(err => {
          if (err) rej(err)
          else {
            self.owner.creds = {accessKeyId: AWS.config.credentials.accessKeyId, secretAccessKey: AWS.config.credentials.secretAccessKey, sessionToken: AWS.config.credentials.sessionToken};
            //sessionStorage.setItem("creds", JSON.stringify({ accessKeyId: AWS.config.credentials.accessKeyId, secretAccessKey: AWS.config.credentials.secretAccessKey, sessionToken: AWS.config.credentials.sessionToken }));
            //self.owner.startTimer()
            if(fromRefresh != true)
              AZEventBus.$emit('onFederate', 'doneFederating');
            res('success')
          }
        })
      })
    },
    completeNewPasswordChallenge: function(user, newPassword, attributesData, callBack) {
      var self = this;
      var cognitoUser = self.cuForCompleteReg;

      cognitoUser.completeNewPasswordChallenge(newPassword, attributesData, {
        onSuccess: function(result) {
          //console.log(result);
          self.cuForCompleteReg = null;
          callBack("success", result);
        },
        onFailure: function(err) {
          console.log(err);
          callBack("error", err);
        }
      });
    },
    logOutUser: function(callBack) {
      var self = this;
      var cognitoUser = self.USER_POOL.getCurrentUser();

      if (cognitoUser != null) {
        cognitoUser.signOut();
        console.log("Signed Out!");
        if (callBack != null) {
          self.federateUser();
          callBack("success");
        }
        return;
      }
      console.log("Error signing out.");
      if (callBack != null) {
        callBack("error");
      }
    },
    sendForgotPasswordCode: function(email, callBack) {
      var self = this;
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser({
        Username: email,
        Pool: self.USER_POOL
      });

      cognitoUser.forgotPassword({
        onSuccess: function(data) {
          //console.log(data);
          callBack("success", data);
        },
        onFailure: function(err) {
          console.log(err);
          callBack("error", err);
        }
      });
    },
    doChangePassword: function(email, code, pass, callBack) {
      var self = this;
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser({
        Username: email,
        Pool: self.USER_POOL
      });

      var verificationCode = code;
      var newPassword = pass;
      cognitoUser.confirmPassword(verificationCode, newPassword, {
        onSuccess() {
          callBack("success");
        },
        onFailure(err) {
          console.log(err);
          callBack("error", err);
        }
      });
    },
    resendConfirmationCode: function(email, callBack) {
      var self = this;
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser({
        Username: email,
        Pool: self.USER_POOL
      });

      cognitoUser.resendConfirmationCode(function(err, result) {
        if (err) {
          console.log(err);
          callBack("error", err);
          return;
        }
        //console.log(result);
        callBack("success", result);
      });
    },
    updateAttributes: function(attributes, callBack) {
      var self = this;
      var cognitoUser = self.USER_POOL.getCurrentUser();

      if (cognitoUser != null) {
        cognitoUser.getSession(function(err, session) {
          if (err) {
            console.log(err);
            return;
          }

          var attributeList = [];

          var attribute = {};
          for (var i = 0; i < attributes.length; i++) {
            attribute = new AmazonCognitoIdentity.CognitoUserAttribute(
              attributes[i]
            );
            attributeList.push(attribute);
          }

          cognitoUser.updateAttributes(attributeList, function(err, result) {
            if (err) {
              console.log(err);
              callBack("error");
              return;
            }
            console.log(result);
            callBack("success");
          });
        });
      }
    },
    changePassword: function(oldPass, newPass, callBack) {
      var self = this;
      var cognitoUser = self.USER_POOL.getCurrentUser();

      if (cognitoUser != null) {
        cognitoUser.getSession(function(err, session) {
          if (err) {
            console.log(err);
            return;
          }

          cognitoUser.changePassword(oldPass, newPass, function(err, result) {
            if (err) {
              console.log(err);
              callBack("error", err);
              return;
            }

            //console.log(result);
            callBack("success", result);
          });
        });
      }
    },
    updateEmail: function(attributes, callBack) {
      var self = this;
      var cognitoUser = self.USER_POOL.getCurrentUser();

      if (cognitoUser != null) {
        cognitoUser.getSession(function(err, session) {
          if (err) {
            console.log(err);
            return;
          }

          var attributeList = [];

          var attribute = {};
          for (var i = 0; i < attributes.length; i++) {
            attribute = new AmazonCognitoIdentity.CognitoUserAttribute(
              attributes[i]
            );
            attributeList.push(attribute);
          }

          cognitoUser.updateAttributes(attributeList, function(err, result) {
            if (err) {
              console.log(err);
              callBack("error", err);
              return;
            }

            //console.log(result);
            callBack("success", result);
          });
        });
      }
    },
    checkVerificationCode: function(code, callBack) {
      var self = this;
      var cognitoUser = self.USER_POOL.getCurrentUser();

      if (cognitoUser != null) {
        cognitoUser.getSession(function(err, session) {
          if (err) {
            console.log(err);
            return;
          }
          confirmCode();
        });
      }

      function confirmCode() {
        cognitoUser.verifyAttribute("email", code, {
          onSuccess: function(result) {
            //console.log(result);
            callBack("success", result);
          },
          onFailure: function(err) {
            console.log(err);
            callBack("error", err);
          }
        });
      }
    },
    resendVerificationCode: function(callBack) {
      var self = this;
      var cognitoUser = self.USER_POOL.getCurrentUser();

      if (cognitoUser != null) {
        cognitoUser.getSession(function(err, session) {
          if (err) {
            console.log(err);
            return;
          }
          sendCode();
        });
      }

      function sendCode() {
        cognitoUser.getAttributeVerificationCode("email", {
          onSuccess: function(result) {
            //console.log(result);
            callBack("success", result);
          },
          onFailure: function(err) {
            console.log(err);
            callBack("error", err);
          },
          inputVerificationCode: null
        });
      }
    },
    getSession: function(callBack){
      const cognitoUser = this.USER_POOL.getCurrentUser();
      if (cognitoUser != null) {
        cognitoUser.getSession((err, session) => {
          if (err){
            callBack('error', err);
            console.log(err)
          } else {
            callBack('success', session);
          }
          return
        })
      } else {
        callBack('error', 'No user');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AZCognito.vue